module.exports = __webpack_public_path__ + "img/activate-vpn-opera-browser.4b169eda.webp";